module.exports = __webpack_public_path__ + "static/media/bookmarkFill.2b864a14.svg";